import API from "@/services/api";
import router from "@/router";

export default {
  fetchTeachersExport() {
    return API().get("teachers");
  },
  fetchTeachers() {
    return API().get("table/teachers");
  },
  fetchClusterTeachers(id) {
    return API().get(`table/teachers/${id}`);
  },
  fetchCoordinatorTeachers(id) {
    return API().get(`coordinators/${id}/teachers`);
  },
  fetchTrainerTeachers(id) {
    return API().get(`trainers/${id}/teachers`);
  },
  fetchTeacherNames() {
    return API().get("teachers/names");
  },
  fetchTeachersBySchool(params) {
    return API().get(`teachers/${params.id}/names`);
  },
  addTeacher(params) {
    return API().post("teachers", params);
  },
  updateTeacher(params) {
    return API().put(`teachers/${router.currentRoute.params.id}`, params);
  },
  getTeacher() {
    return API().get(`teachers/${router.currentRoute.params.id}`);
  },
  fetchTeacherStudents() {
    return API().get(`teachers/${router.currentRoute.params.id}/students`);
  },
  fetchTeacherStudentsById(id) {
    return API().get(`teachers/${id}/students`);
  },
  addTeacherStudent(params) {
    return API().post(
      `teachers/${router.currentRoute.params.id}/students`,
      params
    );
  },
  updateTeacherStudent(teacherId,studentId,params) {
    return API().put(
      `teachers/${teacherId}/students/${studentId}`,
      params
    );
  },
  deleteTeacherStudent(studentId) {
    return API().delete(
      `teachers/${router.currentRoute.params.id}/students/${studentId}`
    );
  },
  updateTeacherActive(params) {
    return API().put(`teachers/${params.id}`, params);
  },
  updateTeacherDuplicate(params) {
    return API().put(`teachers/${params.id}`, params);
  },
  fetchTeacherSchools() {
    return API().get(`teachers/${router.currentRoute.params.id}/schools`);
  },
  fetchTeacherTrainers() {
    return API().get(`teachers/${router.currentRoute.params.id}/trainers`);
  },
  fetchTeacherGroups() {
    return API().get(`teachers/${router.currentRoute.params.id}/groups`);
  },
  fetchTeacherObservations() {
    return API().get(`teachers/${router.currentRoute.params.id}/observations`);
  },
  fetchTeacherModules() {
    return API().get(`teachers/${router.currentRoute.params.id}/modules`);
  },
  fetchTeachersByCountry(params) {
    return API().get(`teachers/country/${params.country}`);
  },
  fetchTeachersByCountryRegion(params) {
    return API().get(
      `teachers/country/${params.country}/region/${params.region}`
    );
  },
  fetchTeachersByCountryRegionDistrict(params) {
    return API().get(
      `teachers/country/${params.country}/region/${params.region}/district/${params.district}`
    );
  },
  fetchTeachersByCountryRegionDistrictVillage(params) {
    return API().get(
      `teachers/country/${params.country}/region/${params.region}/district/${params.district}/village/${params.village}`
    );
  },
  fetchTeachersByCountryVillage(params) {
    return API().get(
      `teachers/country/${params.country}/village/${params.village}`
    );
  },
  fetchTeachersByVillage(params) {
    return API().get(`teachers/village/${params.village}`);
  },

  fetchTeacherParents() {
    return API().get(`teachers/${router.currentRoute.params.id}/parents`);
  },
  fetchTeacherParentWorkshops() {
    return API().get(
      `teachers/${router.currentRoute.params.id}/parents-workshops`
    );
  },
  addTeacherParentWorkshop(params) {
    return API().post(
      `teachers/${router.currentRoute.params.id}/parents-workshops`,
      params
    );
  },
  updateTeacherParentWorkshop(params) {
    return API().put(
      `teachers/${router.currentRoute.params.id}/parents-workshops/${params.id}`,
      params
    );
  },
  deleteTeacherParentWorkshop(studentId) {
    return API().delete(
      `teachers/${router.currentRoute.params.id}/parents-workshops/${studentId}`
    );
  },
  fetchTeacherParentCertificates() {
    return API().get(
      `teachers/${router.currentRoute.params.id}/parents-certificates`
    );
  },
  addTeacherParentCertificate(params) {
    return API().post(
      `teachers/${router.currentRoute.params.id}/parents-certificates`,
      params
    );
  },
  updateTeacherParentCertificate(params) {
    return API().put(
      `teachers/${router.currentRoute.params.id}/parents-certificates/${params.id}`,
      params
    );
  },
  updateTeacherSchoolStatus(params) {
    return API().put(
      `schools/${params.id}/teachers/${router.currentRoute.params.id}`,
      params
    );
  },
  deleteTeacherParentCertificate(params) {
    return API().delete(
      `teachers/${router.currentRoute.params.id}/parents-certificates/${params.id}`
    );
  },
};
